import { ChangeDetectorRef, Component, DestroyRef, Inject, Input, OnInit, Optional, PLATFORM_ID, inject } from '@angular/core';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';
import { FerienHauserService } from '@app/services/ferienhauser/ferienHauser.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'clever-ferienhauserreisende',
    templateUrl: './ferienhauserreisende.component.html',
    styleUrl: './ferienhauserreisende.component.scss',
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class FerienhauserreisendeComponent implements OnInit {
    @Input() mode: string = '';
    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    media: string = 'lg';
    origin: string = 'default';
    zielText: string = 'Gäste';
    ages: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

    destroyRef = inject(DestroyRef);


    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected ferienHauserService: FerienHauserService,
        protected ferienFiltersService: FerienFiltersService,
        protected mediaObserver: BreakpointObserver,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        if(this.isBrowser) {
            this.initFilterSub();
        }
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }

        this.changeDetectorRef.detectChanges();
    }

    async initFilterSub() {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: FerienFIlters) => {
            if (filter) {
                const tmp_persons = filter.adults + filter.children;
                if (tmp_persons === 1) {
                    this.zielText = tmp_persons + ' Gast';
                } else {
                    this.zielText = tmp_persons + ' Gäste';
                }
            }
        });
    }

    async addAdult() {
        if (this.ferienFiltersService.adults < 20) {
            this.ferienFiltersService.adults++;
        }
    }

    async removeAdult() {
        if (this.ferienFiltersService.adults > 1) {
            this.ferienFiltersService.adults--;
        }
    }

    async addChildren() {
        if (this.ferienFiltersService.children < 20) {
            this.ferienFiltersService.children++;
            this.ferienFiltersService.childrenAges.push(-1);
        }
    }

    async removeChildren() {
        if (this.ferienFiltersService.children > -1) {
            this.ferienFiltersService.children--;
            this.ferienFiltersService.childrenAges.pop();
        }
    }

    async selectReisendes() {
        this.showModal = false;
        this.changeDetectorRef.detectChanges();
        this.ferienFiltersService.reisendeResult(this.mode === 'home');
    }

    openModal(ev): void {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev): void {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal(): void {
        this.showModal = false;
        this.changeDetectorRef.detectChanges();
    }

    closeModalMobile(): void {
        this.selectReisendes();
    }

    zoomin(position: any): void {
        this.origin = position;
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.changeDetectorRef.detectChanges();
        });
    }
}
